export default __webpack_public_path__ + "static/media/Run (6).a3c58ffb.png";